import {MaterialType} from '@domain/materials'
import React, {useMemo} from 'react'
import {Navigate} from 'react-router'

import {
  getLastSelectedMaterialType,
  getLastSelectedMaterialId
} from '../helpers/lastSelectedMaterial'
import {useMaterialsQuery} from '../hooks'

import {PLANT_ROUTES, getUrl, useUrlParam} from '@settings/modules/routing'

export const DefaultMaterialTypeRedirect: React.FC = () => {
  const plantCode = useUrlParam('plantCode')
  const {data: allMaterials} = useMaterialsQuery()

  const lastSelectedType = useMemo(() => getLastSelectedMaterialType(plantCode), [plantCode])
  const lastSelectedMaterialId = useMemo(
    () => (lastSelectedType ? getLastSelectedMaterialId(plantCode, lastSelectedType) : null),
    [plantCode, lastSelectedType]
  )

  if (!allMaterials) {
    return null
  }

  if (lastSelectedType && lastSelectedMaterialId) {
    return (
      <Navigate
        to={getUrl(PLANT_ROUTES.MATERIALS.TYPE.MATERIAL_TYPE.ID.MATERIAL_ID.path, {
          plantCode,
          materialType: lastSelectedType,
          materialId: lastSelectedMaterialId
        })}
      />
    )
  }

  if (lastSelectedType) {
    return (
      <Navigate
        to={getUrl(PLANT_ROUTES.MATERIALS.TYPE.MATERIAL_TYPE.path, {
          plantCode,
          materialType: lastSelectedType
        })}
      />
    )
  }

  const firstTypeWithMaterials = Object.values(MaterialType).find((type) =>
    allMaterials.some((material) => material.type === type)
  )

  const selectedType = firstTypeWithMaterials || Object.values(MaterialType)[0]

  return (
    <Navigate
      to={getUrl(PLANT_ROUTES.MATERIALS.TYPE.MATERIAL_TYPE.path, {
        plantCode,
        materialType: selectedType
      })}
    />
  )
}
